import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  margin: 16px 0px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border: 1px solid #ededed;
  border-radius: 4px;
`;

export const Paragraph = styled.div`
  font-size: 14px;
`;

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
`;

export const StepperItem = styled.div`
  display: flex;
  align-items: start;
  gap: 12px;
`;

export const StepperImageFrame = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  height: 44px;
`;

export const StepperLine = styled.div<{ isActive: boolean }>`
  width: 2px;
  height: 12px;
  background-color: ${(props) => (props.isActive ? '#00ab6b' : '#96969699')};
`;

export const StepperLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 24px;
`;

export const PanelContainer = styled.div`
  display: flex;
  align-items: center;

  gap: 12px;

  height: 56px;
  width: 100%;
  padding: 12px 16px;

  background-color: #f2f1fe;
  border-radius: 4px;

  > p {
    height: 100%;
    margin: 0;

    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 12px;
  }
`;

export const PanelIconContainer = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: #e0ddfd;

  > img {
    width: 16px;
    height: 16px;
  }
`;

export const OrderStatusLabel = styled.span<{
  isNegative?: boolean;
}>`
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.isNegative ? '#EE4A49' : '#00AB6B')};
`;
